import { render, staticRenderFns } from "./SelectItemTag.vue?vue&type=template&id=6c4decbb"
import script from "./SelectItemTag.vue?vue&type=script&lang=js"
export * from "./SelectItemTag.vue?vue&type=script&lang=js"
import style0 from "./SelectItemTag.vue?vue&type=style&index=0&id=6c4decbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports